module.exports = __webpack_public_path__ + "static/media/paserg-logo-complete.8fb3868d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/paserg/paserg-logo-complete.png
// module id = 210
// module chunks = 0